var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcBroadcastWhatsapp = function SvgIcBroadcastWhatsapp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E0E0E0",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_16140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 8,
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_200_16140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9125 14.0157C20.9099 13.0174 19.5765 12.4673 18.1557 12.4668C15.2282 12.4668 12.8456 14.836 12.8446 17.7481C12.8441 18.6791 13.0888 19.5877 13.5535 20.3885L12.8 23.1257L15.6155 22.3912C16.3912 22.8122 17.2647 23.0337 18.1535 23.034H18.1557C21.0828 23.034 23.4657 20.6646 23.4667 17.7524C23.4672 16.3411 22.9153 15.0143 21.9125 14.0159V14.0157ZM18.1557 22.1421H18.154C17.362 22.1418 16.585 21.9301 15.9071 21.5302L15.7459 21.435L14.0751 21.8708L14.521 20.2508L14.4161 20.0846C13.9742 19.3857 13.7407 18.5778 13.7412 17.7484C13.7422 15.328 15.7225 13.3588 18.1575 13.3588C19.3366 13.3593 20.4449 13.8164 21.2784 14.6463C22.1119 15.4759 22.5705 16.5791 22.57 17.7519C22.569 20.1725 20.5888 22.1418 18.1557 22.1418V22.1421ZM20.577 18.8543C20.4444 18.7882 19.7919 18.4691 19.6702 18.4251C19.5485 18.381 19.4601 18.359 19.3717 18.4912C19.2834 18.6234 19.029 18.9207 18.9516 19.0086C18.8741 19.0967 18.7967 19.1076 18.664 19.0415C18.5314 18.9754 18.1038 18.8361 17.5968 18.3866C17.2023 18.0366 16.9359 17.6045 16.8585 17.4723C16.7811 17.3401 16.8504 17.2687 16.9166 17.2031C16.9762 17.1439 17.0493 17.0489 17.1157 16.9719C17.1822 16.8949 17.2041 16.8397 17.2484 16.7518C17.2927 16.6637 17.2706 16.5867 17.2375 16.5206C17.2043 16.4545 16.939 15.8049 16.8282 15.5408C16.7205 15.2835 16.611 15.3184 16.5298 15.3141C16.4523 15.3103 16.364 15.3096 16.2754 15.3096C16.1867 15.3096 16.0431 15.3425 15.9214 15.4747C15.7997 15.6069 15.4569 15.9262 15.4569 16.5756C15.4569 17.2249 15.9323 17.8527 15.9988 17.9409C16.0653 18.029 16.9346 19.3619 18.2658 19.9337C18.5823 20.0697 18.8296 20.151 19.0223 20.2118C19.3402 20.3123 19.6295 20.2981 19.8581 20.2642C20.1131 20.2262 20.6433 19.9448 20.7538 19.6366C20.8643 19.3284 20.8643 19.064 20.8312 19.0091C20.7981 18.9541 20.7095 18.9209 20.5768 18.8548L20.577 18.8543Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_16140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_200_16140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(12.8 12.4668)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcBroadcastWhatsapp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-broadcast-whatsapp.5b85701559829bd331098f9f09fc1e28.svg";